import { GET_AUTOMATION_DETAIl_API } from '../../config/constant/apiConstant';
import { paginatedAutomationDetailsActions } from "../../redux/slicers/automation/paginatedAutomationDetails";
import { createGetListAction, createUpdateApiAction } from '../apiGenerator';

export const getAutomationDetailsApi = (id) => createGetListAction({
  endpoint: `${GET_AUTOMATION_DETAIl_API}${id}/`,
  actions: paginatedAutomationDetailsActions,
});

export const automationDetailsUpdateApi = createUpdateApiAction({
  actions: paginatedAutomationDetailsActions,
  endpointUrl: GET_AUTOMATION_DETAIl_API,
})